import { render } from "./FullWidthCtaPreview.vue?vue&type=template&id=5f1cbb97&scoped=true"
import script from "./FullWidthCtaPreview.vue?vue&type=script&lang=js"
export * from "./FullWidthCtaPreview.vue?vue&type=script&lang=js"

import "./FullWidthCtaPreview.vue?vue&type=style&index=0&id=5f1cbb97&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f1cbb97"]])

export default __exports__